import { render, staticRenderFns } from "./ClientAnalytics.vue?vue&type=template&id=554cb502&scoped=true&"
import script from "./ClientAnalytics.vue?vue&type=script&lang=js&"
export * from "./ClientAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./ClientAnalytics.vue?vue&type=style&index=0&id=554cb502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554cb502",
  null
  
)

export default component.exports